import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const PROVEEDORES_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/proveedores?page=${page}${search || ''}`).then(res => res.data);
    },
    getAll: async () => {
        return await API.get('/proveedores-all').then(res => res.data);
    },
    getSheet: async (section, search = null, page, idProveedor) => {
        return API.get(`/proveedores/${idProveedor}?page=${page}&seccion=${section}${search || ''}`).then(res => res.data);
    },
    search: async (proveedor) => {
        return API.post('/proveedores/buscar', proveedor).then(res => res.data);
    },
    getIntegrationProvider: async (proveedor) => {
        return API.post('/proveedores/proveedor-integracion', proveedor).then(res => res.data);
    },
    new: async (proveedor) => {
        return API.post('/proveedores', proveedor).then(res => res.data);
    },
    associate: async (proveedor, name_to_associate) => {
        return API.post('/proveedores/associate', {proveedor: proveedor.id, posible: name_to_associate}).then(res => res.data);
    },
    join: async (data) => {
        return API.post('/proveedores/merge', data).then(res => res.data);
    },
    check: async (proveedor) => {
        return API.post('/proveedores/comprobar', proveedor).then(res => res.data);
    },
    import: async (excel) => {
        return API.post('proveedores/import', excel, headers).then(res => res.data);
    },
    downloadDoc: async (doc) => {
        return API.post('/proveedores/download', {documento: doc}, {responseType: 'blob'}).then(res => res.data);
    },
    exportPurchases: async (data) => {
        return API.post('/proveedores/export', data, {responseType: 'blob'}).then(res => res.data);
    },
    update: async (proveedor) => {
        return API.post('/proveedores/' + (proveedor instanceof FormData ? proveedor.get("id") : proveedor.id) + '/update', proveedor, (proveedor instanceof FormData ? headers : null)).then(res => res.data);
    },
    /****** DESCUENTOS ******/
    newDescuento: async (descuento) => {
        return API.post('/descuentos-proveedor', descuento).then(res => res.data);
    },
    updateDescuento: async (descuento) => {
        return API.put('/descuentos-proveedor/' + descuento.id, descuento).then(res => res.data);
    },
    deleteDescuento: async (idDescuento) => {
        return API.delete('/descuentos-proveedor/' + idDescuento).then(res => res.data);
    },
    /******  TRANSPORTISTAS FAVORITOS ******/
    newTransportistaFav: async (descuento) => {
        return API.post('/transportistas-proveedor', descuento).then(res => res.data);
    },
    updateTransportistaFav: async (descuento) => {
        return API.put('/transportistas-proveedor/' + descuento.id, descuento).then(res => res.data);
    },
    deleteTransportistaFav: async (idDescuento) => {
        return API.delete('/transportistas-proveedor/' + idDescuento).then(res => res.data);
    },
    /****** ALMACENES ******/
    newAlmacen: async (almacen) => {
        return API.post('/almacenes-proveedores', almacen).then(res => res.data);
    },
    updateAlmacen: async (almacen) => {
        return API.put('/almacenes-proveedores/' + almacen.id, almacen).then(res => res.data);
    },
    deleteAlmacen: async (almacenId) => {
        return API.delete('/almacenes-proveedores/' + almacenId).then(res => res.data);
    },
    /****** VACACIONES ******/
    newVacaciones: async (almacen) => {
        return API.post('/vacaciones-proveedores', almacen).then(res => res.data);
    },
    updateVacaciones: async (almacen) => {
        return API.put('/vacaciones-proveedores/' + almacen.id, almacen).then(res => res.data);
    },
    deleteVacaciones: async (almacenId) => {
        return API.delete('/vacaciones-proveedores/' + almacenId).then(res => res.data);
    },
    /****** VALES ******/
    getVale: async (valeId) => {
        return await API.get('/vale-proveedores/' + valeId + '/download', {responseType: 'blob'}).then(res => res.data);
    },
    newVale: async (vale) => {
        return API.post('/vale-proveedores', vale, vale instanceof FormData ? headers : null).then(res => res.data);
    },
    discount: async (vale) => {
        return API.post('/vale-proveedores/' + vale.id + '/discount', vale).then(res => res.data);
    },
    updateVale: async (valeId, vale) => {
        return API.post('/vale-proveedores/' + valeId, vale, vale instanceof FormData ? headers : null).then(res => res.data);
    },
    deleteVale: async (valeId) => {
        return API.delete('/vale-proveedores/' + valeId).then(res => res.data);
    },
    /****** DETALLES ******/
    newDetalle: async (detalle) => {
        return API.post('/detalles-proveedores', detalle).then(res => res.data);
    },
    updateDetalle: async (detalle) => {
        return API.put('/detalles-proveedores/' + detalle.id, detalle).then(res => res.data);
    },
    deleteDetalle: async (detalleId) => {
        return API.delete('/detalles-proveedores/' + detalleId).then(res => res.data);
    },
    /******** AVISOS PIEZAS *********/
    newAviso: async (aviso) => {
        return API.post('/avisos-proveedor', aviso).then(res => res.data);
    },
    updateAviso: async (aviso) => {
        return API.put('/avisos-proveedor/' + aviso.id, aviso).then(res => res.data);
    },
    /******** BLOQUEO TIPO PIEZAS LOGS *********/
    newBloqueoPiezaLog: async (log) => {
        return API.post('/bloqueo-tipo-piezas', log).then(res => res.data);
    }
}